import React, { useState } from 'react';
import { Button, Modal, Form, Input, InputNumber, DatePicker } from 'antd';
import * as Setting from '../utils/AuthUtils';
import { wsBaseHref } from '../AppConfig';
import { Link } from 'react-router-dom';

function AddStage(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);

    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }
    
    async function onFinish(values) {
        // values.stageId = props.seasonId
        console.warn('values della form: ', values)
        const stringDate = values.date.format('YYYY-MM-DDTHH:mm:ssZ')
        values.date = stringDate
        
        const response = await fetch(`${wsBaseHref}/seasons/${props.seasonId}/createstage`, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(values) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())

        window.location.reload(false);
    }

    const linkAddStageAdvanced = "/seasons/"+props.seasonId+"/addstage";

    return(
            <div>
                <Modal title="Add stage" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} cancelText="Cancel" okText="Generate">
                    <Link to={linkAddStageAdvanced}>Clicca per inserire la tappa nella modalità avanzata</Link>
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }}>
                    <Form.Item label="Stage Name" name="name">
                        <Input placeholder="Nome" />
                    </Form.Item>
                    <Form.Item label="Date" name="date">
                        <DatePicker placeholder="Data Tappa" format="DD/MM/YYYY" />
                    </Form.Item>
                    <Form.Item label="Stage Number" name="stageNumber">
                        <InputNumber placeholder='Stage Nr.' />
                    </Form.Item>
                    <Form.Item label="Leg Number" name="round">
                        <InputNumber placeholder='Leg Number' />
                    </Form.Item>
                    <Form.Item label="Swiss Rounds" name="turns">
                        <InputNumber min={0} max={10} placeholder='Rounds' />
                    </Form.Item>
                </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                    ADD STAGE
                </Button>
            </div>
    )
}

export default AddStage;